/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupscolumncreated2Inputs */

const en_signupscolumncreated2 = /** @type {(inputs: Signupscolumncreated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

const de_signupscolumncreated2 = /** @type {(inputs: Signupscolumncreated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt`)
};

/**
* | output |
* | --- |
* | "Created" |
*
* @param {Signupscolumncreated2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupscolumncreated2 = /** @type {((inputs?: Signupscolumncreated2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupscolumncreated2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupscolumncreated2(inputs)
	return de_signupscolumncreated2(inputs)
});
export { signupscolumncreated2 as "signupsColumnCreated" }